var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ArrowLeft02Icon, MessageDownload01Icon } from 'hugeicons-react';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { ChatFeedback } from '../../../../../../../application/common/constants/chat-feedback';
import { useExportChatMutation } from '../../../../../../../application/features/chat-download/chat-download-api';
import { useAppSelector } from '../../../../../../../application/store/useStore';
import useTranslate from '../../../../../../../localization/helpers';
import ChatPDF from '../../../../../chats/chat-section/chat-header/ChatPDF';
import TrainingSegmentDetails from '../segment-details';
import AiMessageTraining from './components/ai-message-training';
import UserMessageTraining from './components/user-message-training';
var ChatInfo = function (_a) {
    var _b, _c;
    var activeMessage = _a.activeMessage, setActiveMessage = _a.setActiveMessage, _d = _a.messages, messages = _d === void 0 ? [] : _d, documents = _a.documents, conversationName = _a.conversationName;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var navigate = useNavigate();
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var isscreen600900Landscape = useMediaQuery('(min-width:600px) and (max-width:900px) and (orientation: landscape)');
    var isscreen600900 = useMediaQuery('(min-width:600px) and (max-width:900px)');
    var handleBackClick = function () {
        navigate(-1);
    };
    var _e = __read(useState(false), 2), isAccordionExpanded = _e[0], setAccordionExpanded = _e[1];
    var _f = __read(useState(false), 2), downloadChatOpen = _f[0], setDownloadChatOpen = _f[1];
    var _g = __read(useState(false), 2), isTrainingSegmentOpen = _g[0], setTrainingSegmentOpen = _g[1];
    var _h = __read(useState(isAccordionExpanded), 2), accordionOpen = _h[0], setAccordionOpen = _h[1];
    var accordionRef = useRef(null);
    var contentRef = useRef(null);
    var _j = __read(useExportChatMutation(), 2), downloadChat = _j[0], downloadChatLoading = _j[1].isLoading;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var activeMessageId = activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.message_id;
    var isDislikedMessage = function (message) {
        return message.feedback === ChatFeedback.Disliked;
    };
    var feedbackMessages = useMemo(function () { return messages.filter(isDislikedMessage); }, [messages]);
    useMemo(function () {
        if (activeMessageId) {
            var container = document.getElementById("message-".concat(activeMessageId));
            container === null || container === void 0 ? void 0 : container.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'start' });
        }
    }, [activeMessageId]);
    var toggleAccordion = function () { return setAccordionExpanded(!isAccordionExpanded); };
    var handleActivateMessage = function (message) {
        if (message.feedback === ChatFeedback.Disliked) {
            setActiveMessage(message);
            if (isXs || isscreen600900) {
                setTrainingSegmentOpen(true);
            }
        }
    };
    var handleBackToChatInfo = function () {
        setTrainingSegmentOpen(false);
        if (activeMessageId) {
            setTimeout(function () {
                var container = document.getElementById("message-".concat(activeMessageId));
                container === null || container === void 0 ? void 0 : container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 0);
        }
    };
    var getMessageBackground = function (messageId) {
        return (activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.message_id) === messageId ? '#00937E14' : 'initial';
    };
    var downloadChatPdf = function () {
        setDownloadChatOpen(true);
        setTimeout(function () {
            exportChatPdf();
        }, 300);
    };
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (accordionRef.current && !accordionRef.current.contains(event.target)) {
                setAccordionOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    var exportChatPdf = useReactToPrint({
        contentRef: contentRef,
        ignoreGlobalStyles: true,
        pageStyle: "@media print {\n                    @page {\n                        size: legal portrait;\n                         @bottom-right {\n                            content: \"Page \" counter(page) \" of \" counter(pages);\n                            font-size: 10px;\n                          }\n                      }\n                  }",
        print: function (printIframe) { return __awaiter(void 0, void 0, void 0, function () {
            var document, html;
            return __generator(this, function (_a) {
                setDownloadChatOpen(false);
                document = printIframe.contentDocument;
                if (document) {
                    html = document.getElementsByTagName('html');
                    downloadChat({ htmlContent: html[0].innerHTML });
                }
                return [2 /*return*/];
            });
        }); }
    });
    return isTrainingSegmentOpen && activeMessage && (isXs || isscreen600900) ? (_jsx(TrainingSegmentDetails, { activeMessage: activeMessage, setActiveMessage: setActiveMessage, messages: feedbackMessages, handleBackToChatInfo: handleBackToChatInfo })) : (_jsxs(Box, { height: '100%', display: 'flex', flexDirection: 'column', width: '100%', sx: {
            backgroundColor: '#FFFFFF',
            borderBottomRightRadius: isXs ? '24px' : '0px',
            borderTopRightRadius: isXs ? '24px' : '0px'
        }, borderRadius: '24px', children: [_jsxs(Accordion, { expanded: accordionOpen, ref: accordionRef, onChange: function (e, expanded) { return setAccordionOpen(expanded); }, sx: {
                    position: 'absolute',
                    zIndex: 1,
                    width: '100%',
                    boxShadow: 'none'
                }, disableGutters: true, children: [_jsxs(AccordionSummary, { "aria-controls": 'panel1a-content', id: 'panel1a-header ', sx: {
                            backgroundColor: 'white',
                            '.MuiAccordionSummary-content': {
                                my: { md: 1.5, xs: 0.5 }
                            }
                        }, children: [isscreen600900Landscape && (_jsx(Box, { display: 'flex', flexDirection: 'row', gap: 0.2, alignItems: 'center', children: _jsx(IconButton, { color: 'primary', onClick: handleBackClick, children: _jsx(ArrowLeft02Icon, { size: 24 }) }) })), _jsxs(Box, { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%', children: [_jsx(Button, { variant: 'text', sx: {
                                            fontSize: '18px',
                                            fontWeight: 700,
                                            color: '#161C24',
                                            '&:hover': {
                                                backgroundColor: '#FFFFFF',
                                                color: '#161C24'
                                            },
                                            p: 1 + '!important',
                                            '& .MuiButton-endIcon': {
                                                color: 'rgba(99, 115, 129, 1)'
                                            }
                                        }, onClick: toggleAccordion, endIcon: isAccordionExpanded ? (_jsx(Icon, { icon: 'eva:arrow-ios-upward-fill' })) : (_jsx(Icon, { icon: 'eva:arrow-ios-downward-fill' })), children: translate('common.documents') }), _jsx(Box, { display: 'flex', flexDirection: 'row', alignItems: 'center', children: _jsx(IconButton, { onClick: function (e) {
                                                e.stopPropagation();
                                                downloadChatPdf();
                                            }, disabled: downloadChatLoading, children: _jsx(MessageDownload01Icon, {}) }) })] })] }), _jsx(AccordionDetails, { sx: { backgroundColor: 'white', maxHeight: '400px', overflow: 'auto', borderRadius: 2 }, children: documents.map(function (document) { return (_jsx(Box, { padding: '16px', width: '100%', boxShadow: '0 10px 48px 0 #919EAB29', display: 'flex', borderRadius: '12px', sx: { cursor: 'pointer' }, children: _jsxs(Box, { display: 'flex', flexDirection: 'column', width: '100%', gap: 0.5, children: [_jsx(Typography, { variant: 'subtitle2', sx: { wordBreak: 'break-all' }, children: document.title }), _jsx(Box, { display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: { xs: 'flex-start', md: 'center' }, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', children: document.fileName }) }), _jsx(Tooltip, { title: document.aiSummary, arrow: true, children: _jsx(Typography, { fontSize: 12, color: '#919EAB', sx: {
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }, children: document.aiSummary }) })] }) }, document.id)); }) })] }), _jsx(Box, { sx: {
                    marginTop: 8.5,
                    flexGrow: 1,
                    overflowY: 'auto',
                    paddingRight: 1
                }, children: messages.map(function (message) { return (_jsxs(Fragment, { children: [_jsx(UserMessageTraining, { message: message }), _jsx(Box, { id: "message-".concat(message.message_id), my: 1, onClick: function () { return handleActivateMessage(message); }, sx: { backgroundColor: getMessageBackground(message.message_id) }, children: _jsx(Box, { p: '8px 20px', children: _jsx(AiMessageTraining, { message: message }) }) })] }, message.message_id)); }) }), downloadChatOpen && (_jsx("div", { style: { display: 'none' }, children: _jsx("div", { ref: contentRef, children: _jsx(ChatPDF, { documents: documents, messages: messages, conversationName: conversationName, userName: currentUser.name, machineName: (_c = (_b = documents[0]) === null || _b === void 0 ? void 0 : _b.machineName) !== null && _c !== void 0 ? _c : '' }) }) }))] }));
};
export default ChatInfo;
